import { BaseService, NOME_TOKEN_ACESSO_DIRETO } from '@thema/base-servicos'

const urlConsultaDiarias = '/service/contabilidade/dotacao/'

class ConsultaDespesasCartaoCorporativoServiceService extends BaseService {
    constructor() {
        const config = JSON.parse(sessionStorage.getItem('config'))
        super(NOME_TOKEN_ACESSO_DIRETO, config)
        const adms = config.adms && config.adms.length > 0 ? config.adms.join() : null
        this.state = {
            adms: adms,
        }
    }

    consultar(filtro) {
        let data = {
            administracao: filtro.administracao.length > 0 ? filtro.administracao.map(e => e.value).join() : this.state.adms,
            exercicio: filtro.exercicio ? filtro.exercicio.value : '',
            periodoUtilizacaoInicial: filtro.periodoUtilizacaoInicial ? filtro.periodoUtilizacaoInicial : null,
            periodoUtilizacaoFinal: filtro.periodoUtilizacaoFinal ? filtro.periodoUtilizacaoFinal : null,
            nomeFavorecido: filtro.nome ? filtro.nome : null,
            cpfFavorecido: filtro.cpf ? filtro.cpf.replace(/^(\d{3}).(\d{3}).(\d{3})-(\d{2})/, '$1$2$3$4') : null,
            cnpjFavorecido: filtro.cnpj ? filtro.cnpj.replace(/\D/g, '') : null,
        }
        return this.conex.post(urlConsultaDiarias + 'consultaDespesasCartaoCorporativo/', JSON.stringify(data))
    }
}

export default ConsultaDespesasCartaoCorporativoServiceService
